"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* istanbul ignore file */
var ToggleSwitchState = /** @class */ (function () {
    function ToggleSwitchState() {
    }
    return ToggleSwitchState;
}());
exports.default = ToggleSwitchState;
//# sourceMappingURL=ToggleSwitchState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/ToggleSwitch/ToggleSwitchState.js
// module id = 1285
// module chunks = 8